import React from 'react';
import { momentParseDate } from '../../../helpers';

interface Props {
    taxDocument: any;
}

const TaxDocumentCondition = ({ taxDocument }: Props) => {
    // Solo mostrar campos de tipo de cambio si la moneda NO es CLP
    const shouldShowExchangeRates = taxDocument?.currency_rate && taxDocument.currency_rate !== 'CLP';
    
    return (
        <div className="tax-document-condition">
            <div className="row">
                {/* Row for Payment Method */}
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="paymentMethod">Método de pago:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={taxDocument?.payment_method || ''}
                            disabled
                        />
                    </div>
                </div>
                
                {/* Spacer column to align the next row underneath */}
                <div className="col-md-6"></div>

                {/* Row for Payment Condition and Due Date */}
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="paymentCondition">Condición de pago:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={taxDocument?.payment_condition || ''}
                            disabled
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="dueDate">Fecha de vencimiento:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={momentParseDate(taxDocument?.due_date || '')}

                            disabled
                        />
                    </div>
                </div>
            </div>

      
      {/* Fechas de Cambio - Solo mostrar para monedas extranjeras */}
            {shouldShowExchangeRates && (
            <div className="row mb-3">
                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="preliminary_exchange_rate_date">
                    Fecha Cambio Provisional:
                    </label>
                    <input
                    type="text"
                    id="preliminary_exchange_rate_date"
                    className="form-control"
                    value={momentParseDate(taxDocument?.preliminary_exchange_rate_date)}
                    disabled
                    />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="final_exchange_rate_date">
                    Fecha Cambio Final:
                    </label>
                    <input
                    type="text"
                    id="final_exchange_rate_date"
                    className="form-control"
                    value={momentParseDate(taxDocument?.final_exchange_rate_date)}
                    disabled
                    />
                </div>
                </div>

            </div>
            )}


              {/* Valores de Cambio - Solo mostrar para monedas extranjeras */}
            {shouldShowExchangeRates && (
            <div className="row mb-3">
                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="preliminary_exchange_rate_date">
                    Valor Cambio Provisional:
                    </label>
                    <input
                    type="text"
                    id="prelim_rate"
                    className="form-control"
                    value={(taxDocument.prelim_rate)}
                    disabled
                    />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="final_exchange_rate_date">
                    Valor Cambio Final:
                    </label>
                    <input
                    type="text"
                    id="final_rate"
                    className="form-control"
                    value={(taxDocument.final_rate)}
                    disabled
                    />
                </div>
                </div>
            </div>
            )}
        </div>

        
    );
};

export default TaxDocumentCondition;
